/* eslint-disable springload/react/prefer-stateless-function */
/* eslint-disable class-methods-use-this */

import algoliasearch from 'algoliasearch';
import { h, Component } from 'preact';
import SearchResults from './SearchResults';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const MAX_SEARCH_RESULTS = 100;

class SearchPage extends Component {
    constructor(props) {
        super(props);
        const searchParams = new URLSearchParams(window.location.search);
        this.state = {
            searchTerm: searchParams.get('q') || '',
            hits: [],
            loadingResults: true,
            language: document
                .querySelector('html')
                .getAttribute('lang')
                .match('en')
                ? 'en'
                : 'mi',
            translations: {},
        };
        this.loadSearchResults();
        this.scrapeTranslations();
    }

    scrapeTranslations() {
        const silverstripeTemplate = document.querySelector(
            '[data-search-banner]',
        );
        const translations = JSON.parse(
            silverstripeTemplate.getAttribute('data-translations'),
        );
        const errorMessage = document.querySelector('[data-search-status]')
            .innerHTML;
        this.setState({
            translations: { ...translations, errorMessage: errorMessage },
        });
    }

    loadSearchResults() {
        if (this.state.searchTerm === '') return;
        this.setState({ loadingResults: true });
        const metaConfig = document.querySelector(
            'meta[name="algolia-config"]',
        );
        if (!metaConfig) {
            console.error('No Algolia config found.');
            return;
        }
        const algoliaConfig = JSON.parse(metaConfig.getAttribute('content'));
        const client = algoliasearch(
            algoliaConfig.applicationIDValue,
            algoliaConfig.apiKeyValue,
        );
        const index = client.initIndex(algoliaConfig.indexNameValue);
        index.search(this.state.searchTerm).then(({ hits }) => {
            if (!document.querySelector('[data-search-results]')) return;
            this.setState({
                hits,
                loadingResults: false,
            });
        });
    }

    searchStatusMessage() {
        const { hits, translations, searchTerm, loadingResults } = this.state;
        const message = {
            plural: `"${searchTerm}" (${hits.length} ${translations.results})`,
            single: `"${searchTerm}" (1 ${translations.result})`,
            loading: `${translations.loading} "${searchTerm}"`, // TODO: add translation
            none: `${translations.noResults} "${searchTerm}"`,
        };
        if (hits.length > 1) return message.plural;
        if (hits.length === 1) return message.single;
        if (loadingResults) return message.loading;
        return message.none;
    }

    updateSubtitle() {
        const subtitle = document.querySelector('[data-search-status]');
        subtitle.textContent = this.searchStatusMessage();
    }

    render() {
        this.updateSubtitle();
        return (
            <SearchResults
                hits={this.state.hits}
                loadingResults={this.state.loadingResults}
            />
        );
    }
}

export default SearchPage;
